import React from 'react';
import ProductCard from './Card';
import pickBy from 'lodash.pickby';
import { CSSTransitionGroup } from 'react-transition-group';
import { menuSlug } from '../utils/menuSlug';

class SpecCardList extends React.PureComponent {
  componentDidMount(){
    window.scrollTo(1, 250)
  }
  render() {
    let card = {};
    let georgeYung = Object.keys(this.props.listedMeals);
    if(this.props.search){
      card = this.props.search
      }
      else {
        const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
        const pathParts = pathname.split('/').filter(Boolean);
        const categoryPath = pathParts[pathParts.length - 1] || '';

        for(let i = 0; i< georgeYung.length; i++){
          let actual = Object.keys(this.props.listedMeals)[i];

          if (
            menuSlug(actual) === categoryPath
            || actual.normalize('NFD').replace(/[\u0300-\u036f]/g, '') === categoryPath
          ) {
            card = pickBy( this.props.fullMeals, (value) => {
              return value.category.match(actual)
            });
          }
        }
      }
    return (
      <div className="marT">
        <div className="clearfix">
            <div className="cardWrapper">
              <CSSTransitionGroup
                transitionName="card"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={300}>
                {Object.values(card).map((meals) =>
                    <ProductCard
                      key={meals.id}
                      meals={meals}
                      onImageClick={this.props.onImageClick}
                    />
                    )
                  }
              </CSSTransitionGroup>
            </div>
          </div>
        </div>
    );
  }
}

export default SpecCardList;
